import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { HttpStatusCode } from 'axios';
import globalProgramStore from '../../../../../stores/program-store';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const deletePaymentServiceOperation = async (
  branchId: number | undefined,
  programId: number | undefined,
  year: number,
  paymentServiceId: number | undefined,
  setLoading: (paymentServiceId: number | null) => any,
) => {
  try {
    if (!branchId || !programId || !paymentServiceId) {
      toast.warn(
        'לא ניתן לאתר את המזהה של התוכנית ו/או הקורס, נסה שוב בעוד מספר רגעים...',
      );
      return;
    }
    setLoading(paymentServiceId);

    const res = await appApi.deletePaymentServiceFromProgram(
      branchId,
      programId,
      year,
      paymentServiceId,
    );
    if (res.status === HttpStatusCode.Ok) {
      if (res.data.errCode) {
        toast.warn(displayErrorText(res.data.errCode));
        setLoading(null);
        return;
      }
      globalProgramStore.updateProgramDetails(programId, res.data.body);
    }
    setLoading(null);
  } catch (e) {
    console.error(
      `deletePaymentServiceOperation is failed with the branchId: ${branchId}, programId: ${programId}, paymentServiceId: ${paymentServiceId} and the error: ${e}`,
    );
    setLoading(null);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
